<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  methods: {
    render() {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    chartData: function() {
      this.$data._chart.update()
    }
  },
}
</script>
